<script>
  export let data;
  export let isScrollytelling;
  export let allData;

  import touchscreen from "@stores/touchscreen.js";
  import ButtonContainer from "@helpers/ButtonContainer.svelte";

  let toNum = (num) => {
    return parseFloat(num.toString().split(",").join(""));
  };

  // If one column is missing, we set the other number to max; if both are present, find max of the two
  function exists(val) {
    return val != "#N/A" && !isNaN(toNum(val));
  }

  $: max = data
    ? exists(data.FY2020) && exists(data.FY2015)
      ? Math.max(toNum(data.FY2020), toNum(data.FY2015))
      : exists(data.FY2020)
      ? toNum(data.FY2020)
      : exists(data.FY2015)
      ? toNum(data.FY2015)
      : 0
    : 0;

  import { format } from "d3-format";
  const suffixFormat = format(",.3s");

  import { fly, fade } from "svelte/transition";

  import { selectedPerformanceMeasures } from "@stores/userData.js";
  $: datas = $selectedPerformanceMeasures;

  // SWIPING
  let xDown = null;
  let yDown = null;

  const X_SWIPE_THRESHOLD = 10; // How intense swipe must be. Might remove this

  function handleTouchStart(evt) {
    if (!evt?.touches) return;
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
  }

  function handleTouchMove(evt) {
    if (!evt?.touches) return;

    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (Math.abs(xDiff) < X_SWIPE_THRESHOLD) return;
      if (xDiff > 0) {
        if (allData.indexOf(data) == allData.length - 1) return;
        data = allData[allData.indexOf(data) + 1];
      } else {
        if (allData.indexOf(data) == 0) return;
        data = allData[allData.indexOf(data) - 1];
      }
    }
    /* reset values */
    xDown = null;
  }
</script>

<div
  on:click={(e) => {
    if ($touchscreen) {
      e.preventDefault();
      e.stopPropagation();
    }
  }}
  on:touchstart={(e) => {
    handleTouchStart(e);
  }}
  on:touchmove={(e) => {
    handleTouchMove(e);
  }}
  class="modal"
  class:touchscreen={$touchscreen}
  class:marginBottomOnTouchscreen={$touchscreen && !isScrollytelling}
  class:hasData={exists(data.FY2015) || exists(data.FY2020)}
  transition:fade
>
  {#key data.Measure}
    <div class="text" in:fly>
      <h2>
        {data.Department}<br /><span style="font-size: 85%"
          >{data.Division}</span
        >
      </h2>
      <h1>{data.Measure}</h1>

      <p>
        The department provided data for this measure in
        {#if exists(data.FY2015) && exists(data.FY2020)}
          both 2015 and 2020.
        {:else if exists(data.FY2015) && !exists(data.FY2020)}
          2015.
        {:else if !exists(data.FY2015) && exists(data.FY2020)}
          2020.
        {:else}
          neither 2015 or 2020.
        {/if}
      </p>
    </div>

    <img
      src="/images/departments/{data.Department}.png"
      alt="Icon for {data.Department}"
    />

    <div class="bottom">
      <div class="barchart">
        {#if exists(data.FY2015)}
          <div
            class="bar"
            data-year="2015"
            style="height: {(toNum(data.FY2015) / max) * 100}%;"
          >
            <span
              >{data.FY2015.toString().includes("%")
                ? data.FY2015
                : suffixFormat(toNum(data.FY2015))}</span
            >
          </div>
        {/if}
        {#if exists(data.FY2020)}
          <div
            class="bar"
            data-year="2020"
            style="height: {(toNum(data.FY2020) / max) * 100}%;"
          >
            <span
              >{data.FY2020.toString().includes("%")
                ? data.FY2020
                : suffixFormat(toNum(data.FY2020))}</span
            >
          </div>
        {/if}
      </div>

      {#if $touchscreen && !isScrollytelling}
        <ButtonContainer styles="flex: 1; margin-left: 10px;">
          <button
            on:click={() => {
              // If selectedPerformanceMeasures includes data, remove it
              if (datas.map((d) => d.Measure).includes(data.Measure)) {
                datas = datas.slice().filter((d) => d.Measure != data.Measure);
              } else {
                // If selectedPerformanceMeasures doesn't include data, add it
                datas = [...datas, data];
              }
              selectedPerformanceMeasures.set(datas);
            }}
            >{datas.map((d) => d.Measure).includes(data.Measure)
              ? "Unselect"
              : "Select"}</button
          >
        </ButtonContainer>
      {/if}
    </div>
  {/key}
</div>

<style>
  .modal {
    cursor: pointer;
    opacity: 0.975;
    background: white;
    width: 500px;
    position: fixed;
    z-index: 10000;
    outline: 3px solid var(--accent-color);
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    bottom: 0;
    left: 0;
    min-height: 0;
    padding: 1rem;
    margin: 1rem;
    pointer-events: none;
  }

  .modal.touchscreen {
    pointer-events: all;
  }

  @media screen and (max-width: 568px) {
    .modal {
      width: 95vw;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
      margin-bottom: 1rem;
    }
  }

  /* .x {
    position: absolute;
    right: 0;
    top: 0;
    display: inline;
    padding: 0.35rem;
    font-size: 1rem;
    font-weight: 900;
    text-transform: uppercase;
    cursor: pointer;
    pointer-events: all;
  } */

  img {
    max-width: 15%;
    max-height: 30%;
    position: absolute;
    top: 3.5%;
    right: 3.5%;
  }

  .touchscreen img {
    top: 7.5%;
  }

  .text {
    max-width: 82.5%;
  }

  .marginBottomOnTouchscreen .text {
    margin-bottom: 2rem;
  }
  /* .x {
    position: absolute;
    top: 1%;
    right: 1.5%;
    cursor: pointer;
  } */

  h1 {
    font-size: 1.6rem;
    line-height: 1.1;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.865);
    /* font-family: var(--font-serif); */
  }

  h2 {
    font-weight: 300;
    color: rgba(var(--text-color-rgb), 0.75);
    font-size: 1.2rem;
    margin-bottom: 0.65rem;
    font-family: var(--font-serif);
  }

  /* h3 {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.015rem;
    margin-bottom: 0.2rem;
    font-family: var(--font-serif);
  } */

  p {
    font-weight: 300;
    line-height: 1.25;
    margin-bottom: 0.5rem;
  }

  .hasData .barchart {
    display: flex;
    height: 120px;
    place-items: flex-end;
    margin-top: 1.2rem;
  }

  .bar {
    margin-right: 0.1vw;
    justify-content: center;
    place-items: flex-start;
    padding-top: 1vw;
    display: flex;
    width: 100%;
    position: relative;
    background: var(--accent-color);
  }

  .bar::after {
    content: attr(data-year);
    position: absolute;
    font-size: 0.8rem;
    color: var(--accent-color);
    top: -1rem;
    left: 0;
  }

  .bar span {
    color: white;
    font-size: 1.35rem;
    font-weight: 400;
    font-family: "Courier New", Courier, monospace;
    bottom: 6px;
    position: absolute;
  }

  .bottom {
    display: flex;
  }

  .barchart {
    flex: 1;
  }

  @media screen and (max-width: 568px) {
    h1 {
      font-size: 1.75rem;
      margin-bottom: 0.75rem;
    }

    h2 {
      font-size: 1.25rem;
      margin-bottom: 0.5rem;
    }
  }
</style>
